import React from 'react'
import { Button, Card, Divider, Header, Icon } from 'semantic-ui-react'
import _ from 'lodash'
import firebase from 'firebase/app'

import Placeholder from './storePlaceholder'
import UnavailableItemCard from './unavailableItemCard'

import UnavailableItemForm from '../forms/unavailableItemForm'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 14px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  addIconWrapper: {
    display: 'flex',
  },
  optionsWrapper: {
    overflow: 'auto',
  },
  optionNameWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}

class UnavailableItemList extends React.Component {
  state = {
    action: '',
    formVisible: false,
    unavailableBranch: [],
  }

  onEditClick = data => {
    this.setState({ unavailableBranch: data, action: 'edit', formVisible: true })
  }

  onDeleteClick = async data => {
    try {
      const { storeId, setUnavailableItem, unavailableItemData } = this.props

      const itemsToRemove = []
      const confirm = window.confirm(`Are you sure to delete this unavailable items?`)

      if (confirm) {
        const batch = firebase.firestore().batch()

        _.forEach(data, item => {
          const ref = firebase
            .firestore()
            .collection('unavailable_items')
            .doc(item.doc_id)

          itemsToRemove.push(item.doc_id)
          batch.delete(ref)
        })

        const remainingData = {}

        _.chain(unavailableItemData.merchantUnavailableItems)
          .filter(item => !itemsToRemove.includes(item.doc_id))
          .forEach(item => {
            remainingData[item.doc_id] = item
          })
          .value()

        await batch.commit()
        setUnavailableItem(storeId, remainingData)
      }
    } catch (error) {
      alert('cannot delete this Unavailable Items for this branch')
    }
  }

  renderLoading = () => <Placeholder />

  renderItemUnavailable = () => {
    const { items, unavailableItemData, merchant } = this.props

    return (
      <Card.Group style={{ margin: 0 }} itemsPerRow={3}>
        {_.map(unavailableItemData.unavailableItemsByBranch, (branchItems, branchKey) => {
          return (
            <UnavailableItemCard
              branchName={_.get(merchant, ['branches', branchKey, 'name'], 'N/A')}
              key={branchKey}
              data={branchItems}
              items={items}
              onEdit={() => this.onEditClick(branchItems)}
              onDelete={() => this.onDeleteClick(branchItems)}
            />
          )
        })}
      </Card.Group>
    )
  }

  renderContent = () => {
    const { items, allBranches, storeId, unavailableItemData, getUnavailableItems } = this.props
    const { formVisible, action, unavailableBranch } = this.state

    return (
      <React.Fragment>
        <div style={styles.container}>
          <div style={styles.headerWrapper}>
            <div style={styles.header}>
              <Header>Unavailable Items ({_.size(unavailableItemData.unavailableItemsByBranch)})</Header>
            </div>
            <div style={styles.addIconWrapper}>
              <Button
                icon
                color="black"
                onClick={() => this.setState({ formVisible: true, action: 'create' })}
              >
                <Icon name="add" /> Add New
              </Button>
            </div>
          </div>

          <div>
            <Divider style={{ margin: 14 }} />
          </div>

          <div style={styles.optionsWrapper} className="branches-summary">
            {this.renderItemUnavailable()}
          </div>
        </div>

        {formVisible && (
          <UnavailableItemForm
            items={items}
            action={action}
            storeId={storeId}
            visible={formVisible}
            unavailableBranch={unavailableBranch}
            allBranches={allBranches}
            onClose={() => this.setState({ formVisible: false })}
            getUnavailableItems={getUnavailableItems}
          />
        )}
      </React.Fragment>
    )
  }

  render() {
    const { loading } = this.props

    if (loading) return this.renderLoading()

    return this.renderContent()
  }
}

export default UnavailableItemList



// WEBPACK FOOTER //
// ./src/components/restaurants/views/unavailableItemList.js